// const token = {
//     "access_token": "BQB6gOYGQZbByPi3we2yiFTnLANzxynKJ7Z3OV2XSIAlWlnhGubtSmRmWMClIPSB5gHlCcUzvUXUzQCPKa3VKoD05HevQbJB7Yu823jQZGTp4tOJs0s",
//     "token_type": "Bearer",
//     "expires_in": 3600
// }

const baseUrl = "https://api.spotify.com/v1"
const canvasUrl = 'https://spclient.wg.spotify.com/canvaz-cache/v0/canvases'

class SpotifyService {

    setToken(token) {
        this.token = token
    }

    getPlayingTrack (token) {
        this.track = ""

        return new Promise((resolve, reject) => {
            fetch(`${baseUrl}/me/player/currently-playing`, {
                method: "GET", headers: { Authorization: `Bearer ${token}` }
            })
            .then(r => r.json())
            .then(r => {
                // console.log(r);
                resolve(r)
            })
            .catch(e => reject(e));
    
        })
    }

    getUserQueue (token) {
        this.track = ""

        return new Promise((resolve, reject) => {
            fetch(`${baseUrl}/me/player/queue`, {
                method: "GET", headers: { Authorization: `Bearer ${token}` }
            })
            .then(r => r.json())
            .then(r => {
                // console.log(r);
                resolve(r)
            })
            .catch(e => reject(e));
    
        })
    }

    async getCanvasTrack (token, id, uri) {
        this.track = ""
        const accessToken = 'BQCdHJXH62J0jYKC4yrrapgSVwgWTOXcubjgIKcGBs4zAEOiR5vKoqpSsLKx2g5202V__TQy37f_QLOnLoRxKPiHd5Xz8rXJGx3GctCynJPiJ0CVr1A' // await fetch('https://open.spotify.com/get_access_token?reason=transport&productType=web_player')
        // .then(response => {
        //     if (response.statusText !== 'OK') {
        //       console.log(`ERROR: ${response.status} ${response.statusText}`);
        //       if (response.data.error) {
        //         console.log(response.data.error);
        //       }
        //     } else {
        //       return response.data.accessToken;
        //     }
        //     return false
        //   })
        //   .catch(error => {console.log(`ERROR: ${error}`)});
            
        return new Promise((resolve, reject) => {
            const data = {
                id,
                uri,
                accessToken
            }
    
    
            fetch(`${canvasUrl}`, {
                method: "POST", 
                responseType: 'arraybuffer',
                headers: {
                    'Accept': 'application/protobuf',
                    "Content-Type": 'application/x-www-form-urlencoded',
                    'Accept-Language': 'en',
                    'User-Agent': 'Spotify/8.5.49 iOS/Version 13.3.1 (Build 17D50)',
                    'Accept-Encoding': 'gzip, deflate, br',
                    Authorization: `Bearer ${token}`,
                  },
                  
                //   { Authorization: `Bearer ${token}` },
                body: JSON.stringify(data),
            })
            // .then(r => r.json())
            .then(r => {
                console.log(r);
                resolve(r)
            })
            .catch(e => reject(e));
    
        })
    }


}

export default SpotifyService